import {
	NavLink,
	Outlet,
	matchPath,
	useLocation,
	useNavigate,
	useParams,
} from "react-router-dom";
import Cart from "../Home/Cart";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "../api/axios";
import LineLoading from "../LineLoading";
import { useDispatch } from "react-redux";
import { add_details } from "../../state/resSlice";
import "./index.css";
import { FaFacebookF, FaInstagram, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Menu = styled.div`
	text-align: center;
	padding-bottom: 10px;
`;

const Heading = styled.h3`
	font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
	display: inline;
`;

const Names = styled.div`
	text-align: center;
	display: flex;
	justify-content: space-around;
	align-items: flex-start;
`;

const Header = () => {
	const params = useParams();

	const cart = useSelector((state) => state.cart.value);

	const cartId = useSelector((state) => state.cart.id);

	const res = useSelector((state) => state.res.value);

	const [count, setCount] = useState(cart.length);

	const [price, setPrice] = useState(0);

	const { pathname } = useLocation();

	const [customer, setCustomer] = useState(null);

	const [payment, setPayment] = useState(null);

	const [resInfo, setResInfo] = useState(false);

	const dispatch = useDispatch();

	const navigate = useNavigate();

	useEffect(() => {
		setCustomer(matchPath("/customer-details/:rid/:tid", pathname));
		setPayment(matchPath("/payment/:rid/:tid/:pid", pathname));
	}, [pathname]);

	useEffect(() => {
		if(resInfo === false) {
		axios
			.post(
					`${
						process.env.REACT_APP_API
							? process.env.REACT_APP_API
							: "http://127.0.0.1:8000/api"
					}/hotel-details`,
					{
						res: params.rid,
					}
				)
				.then((response) => {
					dispatch(add_details(response.data));
					if(!response.data.taking_orders){
					navigate(`/restaurant-closed/${params.rid}/${params.tid}`);
					}
			});
			setResInfo(true);
		}
	}, [params.rid, res, dispatch, resInfo, params, navigate]);

	useEffect(() => {
		setCount(
			cart.reduce(
				(accumulatedPrice, cartItem) => accumulatedPrice + cartItem.quantity,
				0
			)
		);
		setPrice(
			cart.reduce(
				(accumulatedPrice, cartItem) =>
					accumulatedPrice + cartItem.quantity * cartItem.price,
				0
			)
		);
	}, [cart]);
	return (
		<>
			{customer === null &&
				params.tid !== undefined &&
				params.rid !== undefined && (
					<section id="fda_header_bar_t2" className="col-12 sha2">
						<div className="row">
							<Menu className="col-6">
								<span>
									{res ? <Heading>{res.name}</Heading> : <LineLoading />}
								</span>{" "}
								{res && (
									<span>
										{res.mobile && (
											<>
												<a
													href={`tel:${res.mobile}`}
													target="_blank"
													rel="noopener noreferrer"
												>
													<FaPhoneAlt className="text-pink-500 text-2xl" />
												</a>{" "}
											</>
										)}
										{res.instagram && (
											<>
												<a
													href={res.instagram}
													target="_blank"
													rel="noopener noreferrer"
												>
													<FaInstagram className="text-pink-500 text-2xl" />
												</a>{" "}
											</>
										)}
										{res.facebook && (
											<>
												<a
													href={res.facebook}
													target="_blank"
													rel="noopener noreferrer"
												>
													<FaFacebookF className="text-pink-500 text-2xl" />
												</a>{" "}
											</>
										)}
										{res.whatsapp && (
											<>
												<a
													href={`whatsapp://send?phone=${res.whatsapp}`}
													target="_blank"
													rel="noopener noreferrer"
												>
													<FaWhatsapp className="text-pink-500 text-2xl" />
												</a>{" "}
											</>
										)}
										{res.twitter && (
											<>
												<a
													href={res.twitter}
													target="_blank"
													rel="noopener noreferrer"
												>
													<FaXTwitter className="text-pink-500 text-2xl" />
												</a>{" "}
											</>
										)}
									</span>
								)}
							</Menu>
							<Names className="col-6">
								<NavLink
									to={`/order/${params.rid}/${params.tid}`}
									className={({ isActive }) =>
										isActive ? "active_route" : undefined
									}
								>
									<span>
										<i className="fa-solid fa-house wi"></i>
									</span>
								</NavLink>
								<NavLink
									to={`/order-status/${params.rid}/${params.tid}`}
									className={({ isActive }) =>
										isActive ? "active_route" : undefined
									}
								>
									<span>
										<i className="fa-solid fa-clock-rotate-left wi"></i>
									</span>
								</NavLink>
								<NavLink
									to={`/cart/${params.rid}/${params.tid}`}
									className={({ isActive }) =>
										isActive ? "active_route" : undefined
									}
								>
									<span>
										<i className="fa-solid fa-basket-shopping wi"></i>
										<span className="over">{count}</span>
									</span>
								</NavLink>
								<NavLink to={`/customer-details/${params.rid}/${params.tid}`}>
									<span>
										<i className="fa-solid fa-user"></i>
									</span>
								</NavLink>
							</Names>
						</div>
					</section>
				)}
			<Outlet />

			{customer === null && (
				<>
					<section className="col-12" style={{ paddingBottom: "40%" }}>
						<div className="row fda_section_row">
							<div className="col-12">
								<p style={{ textAlign: "center" }}>
									Menu items, nutritional information and price are set directly
									by the restaurant.
								</p>

								<p style={{ textAlign: "center" }}>
									&#169; {new Date().getFullYear()}
								</p>
							</div>
						</div>
					</section>
				</>
			)}
			{payment === null && customer === null && (
				<Cart count={count} price={price} cart={cart} cartId={cartId} />
			)}
		</>
	);
};

export default Header;
